<h2 mat-dialog-title>Confirmación</h2>
<mat-dialog-content style="min-height: 100px">
  Confirma que quiere crear una nueva orden de compra?
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-button mat-dialog-close="true" cdkFocusInitial>Confirmar</button>
  <button mat-button mat-dialog-close="false">Cancelar</button>
</mat-dialog-actions>

<!-- mat-dialog-close='false' -->
